import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'app/core/authentication/authentication.service';
import { PrivateService } from 'app/core/services/private.service';
import { ModalPlanRenewComponent } from '../modal-plan-renew/modal-plan-renew.component';

@Component({
  selector: 'dialog-change-plan',
  templateUrl: './dialog-change-plan.component.html',
  styleUrls: ['./dialog-change-plan.component.scss']
})
export class DialogChangePlanComponent implements OnInit {

  isLoading: boolean = false;

  constructor(public dialogRef: MatDialogRef<DialogChangePlanComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private privateService: PrivateService, private authService: AuthService, private modalService: NgbModal) { }

  ngOnInit(): void {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  openRenewModal(id: number, planId: number) {
    this.dialogRef.close();
    const modalRef = this.modalService.open(ModalPlanRenewComponent, { centered: true });
    modalRef.componentInstance.id = id;
    modalRef.componentInstance.planId = planId;
  }

}
